const QuestionFluff = {
  init() {
    this.sequentiallyShowQuestionParts();
    this.insertVideos();
    this.clickAudio = new Audio('/audio/click.wav');
    this.completeAudio = new Audio('/audio/complete.wav');
    this.errorAudio = new Audio('/audio/error.wav');
    this.answersAudio = new Audio('/audio/answers.wav');
    return this;
  },

  sequentiallyShowQuestionParts() {
    $('.written-content p').each((index, element) => {
      setTimeout(
        ()=> {
          $(element).addClass('opaque');
          new Audio('/audio/paragraph.wav').play();
        },
        (200 * index)
      );
    });
    setTimeout(
      ()=>{
        this.answersAudio.play();
        $('.answer-content').addClass('transition-to-left-0');
      },
      $('.written-content p').length * 200
    );
  },

  markSelected($answer) {
    $answer.addClass('selected grows-shrinks-0-3');
    setTimeout(
      ()=>{ $answer.removeClass('grows-shrinks-0-3') },
      300
    );
    this.clickAudio.play();
  },

  markUnselected($answer, playAudio) {
    $answer.removeClass('selected').addClass('shrinks-grows-0-3');
    setTimeout(
      ()=>{ $answer.removeClass('shrinks-grows-0-3') },
      300
    );
    if (playAudio) this.clickAudio.play();
  },

  revealValue($answer, value) {
    $answer.addClass('pre-reveal-0-5');
    setTimeout(
      ()=>{
        $answer.removeClass('pre-reveal-0-5');
        $answer.addClass(value + ' reveal-' + value)
      },
      500
    );
  },

  playAppropriateAudio(data) {
    if (data.answers_given.some(answerGiven => answerGiven.value < 100 )) {
      if (!data.question_complete) {
        setTimeout(()=>{ this.errorAudio.play(); }, 500);
      }
    } else {
      setTimeout(()=>{ this.completeAudio.play(); }, 500);
    }

  },

  onRevealCompletion(postCompletionFunction) {
    setTimeout(postCompletionFunction, 500);
  },

  insertVideos() {
    if ($('.interstitial').length === 0) return;

    let regExp = /\[video\:(.*)\]/g;
    let newHtml = $('.interstitial').html().replace(regExp, (_, vidKey) => {
      return '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
              vidKey +
              '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
    });
    $('.interstitial').html(newHtml);
  }
};

export default QuestionFluff;
